/**
 * 실행 상태 뱃지 — 「성공(예외 처리)」 를 따로 보인다.
 *
 * 노드가 실패했는데 예외 흐름이 그 실패를 받아 처리하면 실행 전체는 「성공」 으로 끝난다. 그냥 「성공」 으로 적으면
 * 실패가 있었다는 사실이 가려진다 — 주황으로 구분하고 오류 목록에도 올린다(서버 main._handled_failures).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { stateLabel, stateStyle } from '../../services/executionApi';

interface Props {
  state: string | null | undefined;
  handled?: boolean;
  className?: string;
}

const RunStateBadge: React.FC<Props> = ({ state, handled, className = 'px-1.5 py-0.5 rounded-full text-xs font-semibold' }) => {
  const { t } = useTranslation();
  if (handled && state === 'success') {
    return <span className={`${className} bg-amber-100 text-amber-800`} title={t('execution:handled.title')}>{t('execution:handled.label')}</span>;
  }
  return <span className={`${className} ${stateStyle(state)}`}>{stateLabel(state)}</span>;
};

export default RunStateBadge;
